/* Atlas sustainability banner, ported from ac-cat-v2 home-sustainability.js: the spotlight follows the pointer. */
(function () {
  function init(el) {
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-home-sus]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
